import axios from "axios";

export type TestSubmitResponse = {
  passed: boolean;
};

type TestSubmitRequest = {
  answers: Record<string, string>;
  stepId: string;
};

export const getTestResults = async (
  requestBody: TestSubmitRequest
): Promise<TestSubmitResponse> =>
  axios
    .post(
      `${process.env.REACT_APP_API_URL}/user-program/complete-test`,
      requestBody,
      {
        withCredentials: true,
      }
    )
    .then((res) => res.data);
